
export const orderHistoryFormStateConstants = {
    OrderHistoryDisplayForm: 'orderHistoryDisplayForm',
    FileDetailsDisplayForm: 'fileDetailsDisplayForm'
};
